import React, { useContext, useEffect } from "react";
import { AppContext } from "../../store/AppContext";
import Categories from "./components/Categories/Categories";
import AddNewCategory from "./components/AddNewCategory/AddNewCategory";

const CategoriesTab = () => {
  const { categoryTabInfo, selectedTab, setCategoryTabInfo } =
    useContext(AppContext);

  useEffect(() => {
    // Only clear the form overlay — keep page / totalPages so returning
    // from category edit restores the same pagination.
    setCategoryTabInfo((prev) => ({
      ...prev,
      addCategory: false,
      selectedCategory: null,
    }));
  }, []);

  return (
    <>
      {selectedTab?.subCategory?.index === 1 &&
        (categoryTabInfo?.addCategory || categoryTabInfo?.selectedCategory ? (
          <AddNewCategory />
        ) : (
          <Categories />
        ))}
    </>
  );
};

export default CategoriesTab;
